import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { useFetchFreezersApi } from 'api/freezer'
import { useEffectSkipFirst } from 'utils/hooks'
import FreezerVisualizer from './freezer_visualizer'
import { GlobalStateContext } from 'contexts/global_state_context'

type Props = {
    history: H.History
}

const FreezerPage = ({ history }: Props) => {
    // const globalState = useContext(GlobalStateContext)
    const globalState = useContext(GlobalStateContext)
    const freezersApi = useFetchFreezersApi()

    useEffect(() => {
        freezersApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(freezersApi.loading)
    }, [freezersApi.loading])

    return (
        <>
            <ContentHeader headerTitle="フリーザー" />
            <ContentHeader />
            <ContentBody>
                {freezersApi.response.results?.map((freezer, key) => {
                    return (
                        <div style={{ padding: "30px 0", borderBottom: "solid 1px gray"}} key={key}>
                            {freezer.name}
                            <FreezerVisualizer
                                freezer={freezer}
                                onDisposeRack={() => {
                                    freezersApi.execute()
                                }}
                            />
                        </div>
                    )
                })}
            </ContentBody>
        </>
    )
}

export default withRouter(FreezerPage)
